import {Stack, styled} from '@mui/material';
import {FC} from 'react';
import {ContractsTableCreateFilterForm} from './contracts-table-create-filter-form';
import {ContractsTableCreateFiltersModal} from './contracts-table-create-filters-modal';
import {ContractsTableDeleteFiltersModal} from './contracts-table-delete-filters-modal';
import {ContractsTableEditFiltersModal} from './contracts-table-edit-filters-modal';
import {ContractsTableFiltersActions} from './contracts-table-filters-actions';
import {ContractsTableFiltersSets} from './contracts-table-filters-sets';
import {ContractsTableStoreFiltersList} from './contracts-table-store-filters-list';

export const ContractsTableFilters: FC = () => {
  return (
    <Container>
      <ContainerRow>
        <ContainerColumn>
          <ContractsTableCreateFilterForm />
          <ContractsTableFiltersSets />
        </ContainerColumn>
        <ContractsTableFiltersActions />
      </ContainerRow>
      <ContainerRow>
        <ContractsTableStoreFiltersList deletable />
      </ContainerRow>
      <ContractsTableCreateFiltersModal />
      <ContractsTableDeleteFiltersModal />
      <ContractsTableEditFiltersModal />
    </Container>
  );
};

const Container = styled(Stack)({
  alignItems: 'flex-start',
  gap: 16,
  width: '100%',
});

const ContainerColumn = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 30,
});

const ContainerRow = styled(Stack)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: 30,
});
